// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"
import { getFirestore } from "firebase/firestore"
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";

export default async function Firebase()
{
const firebaseConfig = {
  apiKey: "AIzaSyAp08lQk7Jbhh9XIgK5p1Sy6TdGzVXFv1E",
  authDomain: "test-dsl-firebase.firebaseapp.com",
  projectId: "test-dsl-firebase",
  storageBucket: "test-dsl-firebase.firebasestorage.app",
  messagingSenderId: "441111545785",
  appId: "1:441111545785:web:5155f9f73fda47ea2dd868",
  measurementId: "G-YBQHJR04PV"
};


const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)

const db = getFirestore(app);
const docRef = doc(db, "views", "kyTfpomvx0DKxOxlBfYu");
const docSnap = await getDoc(docRef);

const data = docSnap.data()


const updatedViews = data.views + 1

  await updateDoc(docRef, {
      "views": updatedViews
  })

}

